import { render, staticRenderFns } from "./ManagementAdminPage.vue?vue&type=template&id=79a11f73&"
import script from "./ManagementAdminPage.vue?vue&type=script&lang=js&"
export * from "./ManagementAdminPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports